import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { SearchResultsStore } from 'stores/search-results-store';

import { MapToggle } from 'components/search/map/map-toggle';
import { SearchForm } from 'components/common/search-form/index';

import { ILocalization, withLocalization } from 'bernie-l10n';

export interface SidebarProps {
  searchResults: SearchResultsStore;
  isActive: boolean;
  l10n: ILocalization;
}

@withLocalization
@inject('searchResults')
@observer
export class Sidebar extends React.Component<SidebarProps> {
  public static defaultProps = {
    isActive: false,
    l10n: null
  };

  public scrollToTop() {
    window.scrollTo(0, 0);
  }

  public render() {
    const { searchResults, isActive } = this.props;
    const searchCriteria = searchResults && searchResults.searchCriteria;
    const regionId = searchCriteria && searchCriteria.regionId;
    const latLong = searchCriteria && searchCriteria.latLong;
    const shouldShowSidebar = regionId || latLong;
    const { l10n } = this.props;
    const { formatText } = l10n;
    const searchResultsCriteria = searchResults && searchResults.searchCriteria;
    const sortAndFilter = searchResults && searchResults.sortAndFilter;
    const sortAndFilterOptions = sortAndFilter && sortAndFilter.options;
    const sortAndFilterDefaults = sortAndFilter && sortAndFilter.defaults;
    const filters = searchResults && searchResults.searchAndFilterDisplayOptions && searchResults.searchAndFilterDisplayOptions.filters;
    const displayFields = filters && filters.displayFields;
    const ignoreFields = filters && filters.ignoreFields;
    const mapImage = searchResults && searchResults.map && searchResults.map.staticMapSrc;

    return (
      <>
        {shouldShowSidebar && (
          <section data-stid="desktop-sidebar">
            <div className="all-b-padding-six uitk-card-separator-bottom">
              <MapToggle isActive={isActive} mapImage={mapImage} />
            </div>
            <div className="all-t-padding-six">
              <h3 className="is-visually-hidden">{formatText('hotels.searchResults.filtersDialog.title')}</h3>
              <SearchForm
                className="all-b-padding-twelve uitk-dialog__search-form"
                model={searchResultsCriteria}
                sortAndFilterOptions={sortAndFilterOptions}
                sortAndFilterDefaults={sortAndFilterDefaults}
                provideDefaultSubmitButton={false}
                displayFields={displayFields}
                ignoreFields={ignoreFields}
                autoSubmit={true}
                afterSubmit={this.scrollToTop}
                searchable={true}
              />
            </div>
          </section>
        )}
      </>
    );
  }
}
